export default __webpack_public_path__ + "static/media/a7.ed9ca293.png";